import { Flex } from '@sequencehq/core-components'
import { FC } from 'react'
import { InvoiceSummaryStatCard } from './InvoiceSummaryStatCard'
import {
  InvoiceSummaryStat,
  useInvoiceSummaryStats
} from './useInvoiceSummaryStats'
import { useInvoiceStatsCurrencyNav } from './useInvoiceStatsCurrencyNav'

type Props = {
  customerId: string
}

export const InvoiceSummaryStats: FC<Props> = ({ customerId }) => {
  const stats = useInvoiceSummaryStats({ customerId }, 'invoices.summaryStats')
  return (
    <InvoiceSummaryStatsList
      stats={stats}
      data-testid="invoices.summaryStats"
    />
  )
}

type ListProps = {
  stats: InvoiceSummaryStat[]
  'data-testid': string
}

export const InvoiceSummaryStatsList: FC<ListProps> = ({
  stats,
  'data-testid': dataTestId
}) => {
  const {
    activeCurrency,
    showCurrencyNav,
    showCurrencyInFooter,
    goToPreviousCurrency,
    goToNextCurrency
  } = useInvoiceStatsCurrencyNav(stats)

  return (
    <Flex gap="16px" data-testid={dataTestId}>
      {stats.map(stat => (
        <InvoiceSummaryStatCard
          key={stat.testId}
          label={stat.label}
          totals={stat.totals}
          activeCurrency={activeCurrency}
          showCurrencyNav={showCurrencyNav}
          showCurrencyInFooter={showCurrencyInFooter}
          onPreviousCurrency={goToPreviousCurrency}
          onNextCurrency={goToNextCurrency}
          isLoading={stat.isLoading}
          emphasize={stat.emphasize}
          data-testid={stat.testId}
        />
      ))}
    </Flex>
  )
}
